<template>
  <v-container id="pedidos" tag="section">
    <base-v-component heading="Pedidos del sistema " />
    <base-material-card color="indigo" icon="mdi-account-multiple" inline class="px-5 py-3">
      <v-toolbar flat color="white">
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="pedidos"
        :loading="loading"
        :search="search"
        :must-sort="true"
        sort-by="fecha"
        :sort-desc="true"
      >
        <template v-slot:item="{ item }">
          <tr :class="(item.eliminado) ? 'red lighten-2' : ''">
            <td>{{item.numPedidoRest}}</td>
            <td>{{item.fecha}}</td>
            <td>{{item.modo}}</td>
            <td>{{item.forma_pago}}</td>
            <td>{{item.cantidad}}</td>
            <td>{{item.nombreRest}}</td>
            <td>
              <v-row>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      disabled
                      class="px-2 ml-1"
                      color="green"
                      min-width="0"
                      small
                      v-on="on"
                      @click="goView(item)"
                    >
                      <v-icon small>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver pedido {{item.id}}</span>
                </v-tooltip>
              </v-row>
            </td>
          </tr>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { mostrarMoneda } from "@/utils/utils.js";

export default {
  data() {
    return {
      loadingRefund: false,
      loading: false,
      search: "",
      headers: [
        {
          sortable: false,
          text: "Pedido Restaurante",
          value: "numPedidoRest",
        },
        {
          sortable: false,
          text: "Fecha",
          value: "fecha",
        },
        {
          sortable: false,
          text: "Modo",
          value: "modo",
        },
        {
          sortable: false,
          text: "Forma de pago",
          value: "forma_pago",
        },
        {
          sortable: false,
          text: "Cantidad",
          value: "cantidad",
        },
        {
          sortable: false,
          text: "Restaurante",
          value: "nombreRest",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      //pedidos : (state) => state.pedidos.pedidosArray
    }),
    ...mapGetters({
      pedidosBruto: "pedidos/getPedidosRestauranteListado",
    }),
    pedidos() {
      return this.pedidosBruto.map((p) => {
        return {
          ...p,
          nombreRest: p.copyNegocio.nombre + " " + p.copyRest.nombre,
          cantidad: mostrarMoneda(p.precioTotal),
        };
      });
    },
  },
  methods: {
    reload() {
      this.getPedidos();
    },
    getPedidos() {
      this.loading = true;
      let _vm = this;
      return this.$store
        .dispatch("pedidos/getPedidosRestaurante")
        .finally(() => {
          _vm.loading = false;
        });
    },
    goView(item) {
      alert("por implementar");
      /*let str = "/admin/pedidos/view/" + item.id;
      this.$router.push(str);*/
    },
  },
  mounted() {},
};
</script>

<style>
</style>